import { DataTableCellProps, TableCell } from 'components/dataTable';
import { CustodialWalletTransactionStatusBadge } from 'components/pwcRefundTransactionBadge';

export const StatusCell = ({ row, column }: DataTableCellProps) => {
  const value = row[column.id];

  return (
    <TableCell data-column={column.id}>
      <CustodialWalletTransactionStatusBadge status={value} />
    </TableCell>
  );
};
